exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".embed-page-wrapper[data-v-46449d1d]{width:100%;padding-bottom:10px}", ""]);

// exports
